import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Shbutton from "../../../theme/buttons/Shbutton";
import SHModal from "../../../theme/Modal/SHModal";
import Subheading from "../../../theme/text/Subheading";
import Text from "../../../theme/text/Text";
import { tokens } from "../../../../theme";

export const MTooManyPalletSpots = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const groupedByRelation = {};
    props.palletspots?.forEach(spot => {
        const relationKey = spot.relationId || 'unknown';
        const relationName = spot.relationName;

        if (!groupedByRelation[relationKey]) {
            groupedByRelation[relationKey] = {
                relationName,
                spots: []
            };
        }
        groupedByRelation[relationKey].spots.push(spot);
    });

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >

            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("view_stock")}</Subheading>
            </Box>
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                <Box
                    sx={{
                        display:"grid",
                        gridTemplateColumns:"repeat(2, 1fr)",
                        gap:4,
                        maxHeight:500,
                        overflow:'auto',
                    }}
                >
                    {Object.entries(groupedByRelation).map(([relationKey, relationData], zoneIdx) => (
                        <Box
                            key={"zone-"+relationKey}
                            sx={{
                                width:300,
                            }}
                        >
                            <Text noBreak bold sx={{mb:1}}>{relationData.relationName}</Text>
                            <Box
                                sx={{
                                    display:"flex",
                                    gap:4,
                                }}
                            >
                                <Text noBreak light sx={{flex:1}}>{t("date")}</Text>
                                <Text noBreak light sx={{flex:1}}>{t("total_quantity")}</Text>
                            </Box>
                            {relationData.spots.map((spot,idx) => (
                                <Box
                                    key={"prps"+idx}
                                    sx={{
                                        width:1,
                                        display:"flex",
                                        gap:4,
                                        mt:1,
                                    }}
                                >
                                    <Text noBreak sx={{flex:1}}>{new Date(spot.date)?.toISOString().split('T')[0]}</Text>
                                    <Text noBreak sx={{flex:1}}>{spot.amountOfProducts}</Text>
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Box>

            </Box>
            <Box
                component="footer"
                sx={{
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                {/* <ButtonGroup version={2}>
                    <Shbutton 
                    isLoading={isLoading}
                    className={"group-btn"} 
                    color={"green"}
                    variant="contained" 
                    onClick={() => saveChildProducts(props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup> */}
            </Box>
        </SHModal>
    )
}